import { useQuery } from '@apollo/client';
import { GET_DTOOLS_AUTH_DETAILS } from 'src/graphql/entities/integrations/dtools/dtools.operations';
import {
  DtoolsAuthDetailsInput,
  DtoolsAuthResponse,
} from 'src/graphql/entities/integrations/dtools/dtools.types';
import { useGlobalStore } from 'src/store';
import { useNotifications } from 'src/utils/hooks';

export const useGetDtoolsAuthDetails = () => {
  const { showErrorAlert } = useNotifications();
  const partnerId = useGlobalStore.use.selectedPartnerId();
  const { data, loading } = useQuery<DtoolsAuthResponse, DtoolsAuthDetailsInput>(GET_DTOOLS_AUTH_DETAILS, {
    variables: {
      params: {
        partnerId: partnerId!,
      },
    },
    skip: partnerId === null,
    onError: (data) => {
      showErrorAlert(data.message);
    },
  });

  return {
    dtoolsAuthDetails: data?.getDtoolsAuthDetails?.authDetails,
    loading,
  };
};
